export default __webpack_public_path__ + "static/media/ic_notes.705163e1.webp";